import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../selectors/customers'
import prepareHeaders from '../utils/prepareHeaders'

const url = '/secure/policies/intune/deviceAppManagement-mobileApps'

export const intuneMobileAppsApi = createApi({
  reducerPath: 'intuneMobileApps',
  baseQuery: fetchBaseQuery({
    prepareHeaders,
    baseUrl: process.env.REACT_APP_AUGMENTT_API_URL,
  }),
  endpoints: (builder) => ({
    getMobileApps: builder.query({
      query: (customerId) => ({
        url,
        params: { customerId },
      }),
    }),
    getMobileAppById: builder.query({
      query: ({ customerId, appId }) => ({
        url: `${url}/${appId}`,
        params: { customerId },
      }),
    }),
    createMobileApp: builder.mutation({
      query: ({ customerId, userId, payload, source }) => ({
        url,
        params: { customerId, userId, source },
        method: 'POST',
        body: payload,
      }),
    }),
    deleteMobileApp: builder.mutation({
      query: ({ customerId, userId, policyId }) => ({
        url,
        params: { customerId, userId, policyId },
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useGetMobileAppsQuery,
  useLazyGetMobileAppsQuery,
  useGetMobileAppByIdQuery,
  useLazyGetMobileAppByIdQuery,
  useCreateMobileAppMutation,
  useDeleteMobileAppMutation,
} = intuneMobileAppsApi

export const useGetMobileApps = (options = {}) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetMobileAppsQuery(customerId, options)
}

export const useGetMobileAppById = ({ appId }, options) => {
  const customerId = useSelector(getSelectedCustomerId)

  return useGetMobileAppByIdQuery({ customerId, appId }, options)
}
